import { IndiaWizardBillingProductTags } from './india';
import { USWizardBillingProductIds } from './us';

export enum SingaporeWizardBillingProductTags {
  // Charges (one-time):
  SINGAPORE_PTE_LTD_INCORPORATION = 'SG-Incorporation-Product',
}

export enum UKWizardBillingProductTags {
  // Charges (one-time):
  UK_INCORPORATION = 'UK-Incorporation',
}

export enum IrelandWizardBillingProductTags {
  // Charges (one-time):
  IRELAND_INCORPORATION = 'Ireland-Incorporation',
}

enum PricingVariant {
  SelfServeFlow = 'Incorporation-Bundle',
}

enum TransferPricingProductIds {
  BENCHMARKING_STUDY = 'Transfer-Pricing-Document---Benchmark-Study',
  GUIDANCE_MEMO = 'Transfer-Pricing-Document---Guidance-Memo',
  INTERCOMPANY_AGREEMENT = 'Transfer-Pricing-Document---Inter-company-Agreements-ICA',
  LOCAL_FILE = 'Transfer-Pricing-Document---Local-File',
  GROWTH_PACK = 'Transfer-Pricing--Growth-Pack',
  STARTER_PACK = 'Transfer-Pricing-Start-up-Pack',
}

enum CompliancePricingBasicProductIds {
  COMPLIANCE_BASIC_US = 'Compliance-Basic-US',
  COMPLIANCE_BASIC_UK = 'Compliance-Basic-UK',
  COMPLIANCE_BASIC_SG = 'Compliance-Basic-SG',
  COMPLIANCE_BASIC_IN = 'Compliance-Basic-IN',
  COMPLIANCE_BASIC_IE = 'Compliance-Basic-IE',
}

enum CompliancePricingPlusProductIds {
  COMPLIANCE_PLUS_US = 'Compliance-Plus-US',
  COMPLIANCE_PLUS_UK = 'Compliance-Plus-UK',
  COMPLIANCE_PLUS_SG = 'Compliance-Plus-SG',
  COMPLIANCE_PLUS_IN = 'Compliance-Plus-IN',
}

type BillingProductTags =
  | USWizardBillingProductIds
  | IndiaWizardBillingProductTags
  | SingaporeWizardBillingProductTags
  | UKWizardBillingProductTags
  | IrelandWizardBillingProductTags
  | TransferPricingProductIds
  | CompliancePricingBasicProductIds
  | CompliancePricingPlusProductIds;

export * from './india';
export * from './us';
